export class ResizeAF {
  private static onScrollFunctionList: Array<(s: number) => void> = [];
  private static onResizeFunctionList: Array<(s: number) => void> = [];
  private static onceFunctionList: Array<{ func: (s: number) => boolean, resolved: boolean }> = [];

  private static lastScroll: number = window.scrollY;
  private static ticking = false;
  private static _instance: ResizeAF | null = null;

  private constructor() {
    window.addEventListener('resize', () => {
      ResizeAF.lastScroll = window.scrollY;
      this.requestTickOnResize();
      ResizeAF.ticking = true;
    });
    window.addEventListener('scroll', () => {
      ResizeAF.lastScroll = window.scrollY;
      this.requestTickOnScroll();
      ResizeAF.ticking = true;
    });
  }

  static instance(): ResizeAF {
    if (this._instance == null) {
      this._instance = new ResizeAF();
    }

    return this._instance;
  }

  private static callOneTimeFunction() {
    ResizeAF.onceFunctionList.forEach((func, index) => {
      if (func.resolved) {
        return;
      }

      const res = func.func(ResizeAF.lastScroll);

      if (res) {
        func.resolved = true;
      }
    });
  }

  on(func: (s: number) => void, scroll: boolean = true) {
    if (scroll) {
      ResizeAF.onScrollFunctionList.push(func);
    }

    ResizeAF.onResizeFunctionList.push(func);
  }

  onScroll(func: (s: number) => void) {
    ResizeAF.onScrollFunctionList.push(func);
  }

  onResize(func: (s: number) => void) {
    ResizeAF.onResizeFunctionList.push(func);
  }

  once(func: (s: number) => boolean) {
    ResizeAF.onceFunctionList.push({ func: func, resolved: false });
  }

  trigger() {
    this.requestTickOnScroll();
    this.requestTickOnResize();
  }

  private updateOnScroll() {
    ResizeAF.onScrollFunctionList.forEach((func) => {
      func(ResizeAF.lastScroll);
      ResizeAF.callOneTimeFunction();
      ResizeAF.ticking = false;
    });
  }

  private updateOnResize() {
    ResizeAF.onResizeFunctionList.forEach((func) => {
      func(ResizeAF.lastScroll);
      ResizeAF.callOneTimeFunction();
      ResizeAF.ticking = false;
    });
  }

  private requestTickOnScroll() {
    if (ResizeAF.ticking) return;

    window.requestAnimationFrame(this.updateOnScroll);
  }

  private requestTickOnResize() {
    if (ResizeAF.ticking) return;

    window.requestAnimationFrame(this.updateOnResize);
  }
}
